import React from 'react';
import InfoTooltip from '../tooltips/InfoTooltip';
import CountField from '../fields/CountField';
import {useSelector} from 'react-redux';
import useFieldRules from '../../hooks/useFieldRules';
import useSyncedField from '../../hooks/useSyncedField';
import fieldTooltips from '../../helpers/fieldTooltips';
import {useFormState} from 'react-final-form';
import {universalPagesValidation} from '../../helpers/universalPagesValidation';

function VisualPiece() {
    const {values} = useFormState();
    const {limits} = useSelector(state => state.orderOptions.data);
    const {isVisible} = useFieldRules('visualPiece');
    useSyncedField('visualPiece', 'int');

    if (!isVisible) return null;

    return (
        <div className="form-group form-control-pages">
            <div className="form-label d-flex">
                {limits && limits.visualPiece ? limits.visualPiece.label : ''}
                {values && values.visualPiece > 1 ? 's' : ''}
                <InfoTooltip>
                    <p>{fieldTooltips.visualPiece}</p>
                </InfoTooltip>
            </div>
            <CountField
                name="visualPiece"
                validate={universalPagesValidation('visualPiece')}
            />
        </div>
    );
}

export default VisualPiece;
